import { render, staticRenderFns } from "./PersonProfileAssociatedLocationInfoDetails.vue?vue&type=template&id=868f3648&scoped=true&"
import script from "./PersonProfileAssociatedLocationInfoDetails.vue?vue&type=script&lang=js&"
export * from "./PersonProfileAssociatedLocationInfoDetails.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileAssociatedLocationInfoDetails.vue?vue&type=style&index=0&id=868f3648&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868f3648",
  null
  
)

export default component.exports